"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssignationDto = void 0;
/* eslint-disable eqeqeq */
const legacy_enums_1 = require("@daytrip/legacy-enums");
const utils_1 = require("@daytrip/utils");
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const Chargeback_1 = require("../models/Chargeback");
const Compensation_1 = require("../models/Compensation");
const Payment_1 = require("../models/Payment");
const Penalty_1 = require("../models/Penalty");
const Subsidy_1 = require("../models/Subsidy");
let AssignationDto = class AssignationDto {
    _id;
    createdAt = new Date();
    departureAt;
    orderId;
    userId;
    vehicleType;
    price;
    penalties;
    subsidies;
    compensations;
    payments;
    chargebacks;
    // The Assignation is accepted: if the vehicle is undefined, acceptation note is defined and contrariwise
    vehicleId;
    acceptationNote;
    subsidyIds = new Array();
    compensationIds = new Array();
    penaltyIds = new Array();
    acceptedAt;
    declinedAt;
    cancelledAt;
    reason;
    payoutId;
    get status() {
        if ((0, utils_1.isNotUndefinedOrNull)(this.cancelledAt)) {
            return legacy_enums_1.AssignationStatus.Cancelled;
        }
        if ((0, utils_1.isNotUndefinedOrNull)(this.declinedAt)) {
            return legacy_enums_1.AssignationStatus.Declined;
        }
        if ((0, utils_1.isNotUndefinedOrNull)(this.acceptedAt)) {
            return legacy_enums_1.AssignationStatus.Accepted;
        }
        return legacy_enums_1.AssignationStatus.Pending;
    }
    get penaltiesAmount() {
        return (0, utils_1.isNotUndefinedOrNull)(this.penalties) ? this.penalties.reduce((s, p) => p.value + s, 0) : 0;
    }
    get compensationsAmount() {
        return (0, utils_1.isNotUndefinedOrNull)(this.compensations) ? this.compensations.reduce((s, p) => p.value + s, 0) : 0;
    }
    get subsidiesAmount() {
        if (this.status == legacy_enums_1.AssignationStatus.Accepted) {
            return (0, utils_1.isNotUndefinedOrNull)(this.subsidies) ? this.subsidies.reduce((s, p) => p.value + s, 0) : 0;
        }
        return 0;
    }
    get moneyOperations() {
        return -this.penaltiesAmount + this.compensationsAmount + this.subsidiesAmount;
    }
    get totalAmount() {
        return this.price + this.moneyOperations;
    }
};
exports.AssignationDto = AssignationDto;
__decorate([
    (0, class_validator_1.IsUUID)("4"),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], AssignationDto.prototype, "_id", void 0);
__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => Date),
    __metadata("design:type", Date)
], AssignationDto.prototype, "createdAt", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Date)
], AssignationDto.prototype, "departureAt", void 0);
__decorate([
    (0, class_validator_1.IsUUID)("4"),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], AssignationDto.prototype, "orderId", void 0);
__decorate([
    (0, class_validator_1.IsUUID)("4"),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", String)
], AssignationDto.prototype, "userId", void 0);
__decorate([
    (0, class_validator_1.IsInt)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], AssignationDto.prototype, "vehicleType", void 0);
__decorate([
    (0, class_validator_1.IsInt)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    __metadata("design:type", Number)
], AssignationDto.prototype, "price", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => Penalty_1.Penalty),
    __metadata("design:type", Array)
], AssignationDto.prototype, "penalties", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => Subsidy_1.Subsidy),
    __metadata("design:type", Array)
], AssignationDto.prototype, "subsidies", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => Compensation_1.Compensation),
    __metadata("design:type", Array)
], AssignationDto.prototype, "compensations", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => Payment_1.Payment),
    __metadata("design:type", Array)
], AssignationDto.prototype, "payments", void 0);
__decorate([
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => Chargeback_1.Chargeback),
    __metadata("design:type", Array)
], AssignationDto.prototype, "chargebacks", void 0);
__decorate([
    (0, class_validator_1.IsUUID)("4"),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)(({ value }) => ((0, utils_1.isUndefinedOrNull)(value) ? undefined : value)),
    __metadata("design:type", String)
], AssignationDto.prototype, "vehicleId", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)(({ value }) => ((0, utils_1.isUndefinedOrNull)(value) ? undefined : value)),
    __metadata("design:type", String)
], AssignationDto.prototype, "acceptationNote", void 0);
__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => String),
    __metadata("design:type", Array)
], AssignationDto.prototype, "subsidyIds", void 0);
__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => String),
    __metadata("design:type", Array)
], AssignationDto.prototype, "compensationIds", void 0);
__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => String),
    __metadata("design:type", Array)
], AssignationDto.prototype, "penaltyIds", void 0);
__decorate([
    (0, class_validator_1.IsDate)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)(({ value }) => ((0, utils_1.isUndefinedOrNull)(value) ? undefined : value)),
    __metadata("design:type", Date)
], AssignationDto.prototype, "acceptedAt", void 0);
__decorate([
    (0, class_validator_1.IsDate)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)(({ value }) => ((0, utils_1.isUndefinedOrNull)(value) ? undefined : value)),
    __metadata("design:type", Date)
], AssignationDto.prototype, "declinedAt", void 0);
__decorate([
    (0, class_validator_1.IsDate)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)(({ value }) => ((0, utils_1.isUndefinedOrNull)(value) ? undefined : value)),
    __metadata("design:type", Date)
], AssignationDto.prototype, "cancelledAt", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)(({ value }) => ((0, utils_1.isUndefinedOrNull)(value) ? undefined : value)),
    __metadata("design:type", String)
], AssignationDto.prototype, "reason", void 0);
__decorate([
    (0, class_validator_1.IsUUID)("4"),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Transform)(({ value }) => ((0, utils_1.isUndefinedOrNull)(value) ? undefined : value)),
    __metadata("design:type", String)
], AssignationDto.prototype, "payoutId", void 0);
exports.AssignationDto = AssignationDto = __decorate([
    (0, class_transformer_1.Exclude)()
], AssignationDto);
//# sourceMappingURL=AssignationDto.js.map